import addComment from "@/assets/icons/add_comment_img.png"
import addEventHome from "@/assets/icons/add_event_home.png"
import addEventIcon from "@/assets/icons/add_event_icon.png"
import addEvent from "@/assets/icons/add_event.png"
// import addReport from "@/assets/icons/add_event_icon.png"
import addSquad from "@/assets/icons/add_squad_button.png"
import ankleRed from "@/assets/icons/ankle_icon_red.png"
import ankleWhite from "@/assets/icons/ankle_icon_white.png"
import appLoginLogo from "@/assets/icons/app_login_logo.png"
import armRed from "@/assets/icons/arm_icon_red.png"
import armWhite from "@/assets/icons/arm_icon_white.png"
import attendingEvent from "@/assets/icons/attending_event_icon.png"
import attending from "@/assets/icons/attending_icon.png"
import backRed from "@/assets/icons/back_icon_red.png"
import backWhite from "@/assets/icons/back_icon_white.png"
import basket from "@/assets/icons/basket.png"
import basketWhite from "@/assets/icons/basket_white.png"
import calfRed from "@/assets/icons/calf_icon_red.png"
import calfWhite from "@/assets/icons/calf_icon_white.png"
import chestRed from "@/assets/icons/chest_icon_red.png"
import chestWhite from "@/assets/icons/chest_icon_white.png"
import clock from "@/assets/icons/clock_icon.png"
import coachRed from "@/assets/icons/coach_icon_red.png"
import coach from "@/assets/icons/coach_icon.png"
import commentAdded from "@/assets/icons/comment_added_img.png"
import contentCopy from "@/assets/icons/content-copy.png"
import contentCopyWhite from "@/assets/icons/content-copy-white.png"
import currentStreak from "@/assets/icons/current_streak_icon.png"
import defaultProfileImg from "@/assets/icons/default_profile_image.png"
import defaultIcon from "@/assets/icons/default_icon.png"
import defaultTeamImg from "@/assets/icons/team_img.png"
import defender from "@/assets/icons/defender_icon.png"
import eventCreatorGrey from "@/assets/icons/event_creator_grey.png"
import eventCreator from "@/assets/icons/event_creator_icon.png"
import eventSharingOff from "@/assets/icons/event_sharing_off.png"
import eventSharingOn from "@/assets/icons/event_sharing_on.png"
import eventsCalendar from "@/assets/icons/events_calendar_icon.png"
import event from "@/assets/icons/events_icon.png"
import fivePeople from "@/assets/icons/five_people.png"
import footRed from "@/assets/icons/foot_icon_red.png"
import footWhite from "@/assets/icons/foot_icon_white.png"
import fourPeople from "@/assets/icons/four_people.png"
import game from "@/assets/icons/game_icon_new.png"
import goalkeeper from "@/assets/icons/goalkeeper_icon.png"
import graph from "@/assets/icons/graph_image.png"
import greenCheck from "@/assets/icons/green_check.png"
import groinRed from "@/assets/icons/groin_icon_red.png"
import groinWhite from "@/assets/icons/groin_icon_white.png"
import hamstringRed from "@/assets/icons/hamstring_icon_red.png"
import hamstringWhite from "@/assets/icons/hamstring_icon_white.png"
import headRed from "@/assets/icons/head_icon_red.png"
import headWhite from "@/assets/icons/head_icon_white.png"
import hipRed from "@/assets/icons/hip_icon_red.png"
import hipWhite from "@/assets/icons/hip_icon_white.png"
import home from "@/assets/icons/home_icon.png"
import injuredPlayer from "@/assets/icons/injured_players.png"
import injury from "@/assets/icons/injury_img1.png"
import joinTeam from "@/assets/icons/join_team.png"
import kneeRed from "@/assets/icons/knee_icon_red.png"
import kneeWhite from "@/assets/icons/knee_icon_white.png"
import launchBanner from "@/assets/icons/launch_banner_icon_android.png"
import location from "@/assets/icons/location_icon.png"
import logOut from "@/assets/icons/log_out.png"
import manageSquadDrawer from "@/assets/icons/manage_squad_drawer_icon.png"
import meeting from "@/assets/icons/meeting_icon_new.png"
import messageInbox from "@/assets/icons/message_inbox1.png"
import messengerIcon from "@/assets/icons/messenger_icon.png"
import midfielder from "@/assets/icons/midfielder_icon.png"
import miscInjury from "@/assets/icons/misc_injury_icon.png"
import happy from "@/assets/icons/mood_happy.png"
import neutral from "@/assets/icons/mood_neutral.png"
import sad from "@/assets/icons/mood_sad.png"
import myStatus from "@/assets/icons/my_status_image.png"
import neckRed from "@/assets/icons/neck_icon_red.png"
import neckWhite from "@/assets/icons/neck_icon_white.png"
import newMessage from "@/assets/icons/new_message_icon.png"
import noResponseEvent from "@/assets/icons/no_response_event.png"
import noResponse from "@/assets/icons/no_response_icon.png"
import notAttending from "@/assets/icons/not_attending_icon.png"
import notSelected from "@/assets/icons/not_selected.png"
import onePerson from "@/assets/icons/one_person_img.png"
import pinRed from "@/assets/icons/pin_icon_red.png"
import player from "@/assets/icons/player_icon.png"
import profile from "@/assets/icons/profile_icon.png"
import quadRed from "@/assets/icons/quad_icon_red.png"
import quadWhite from "@/assets/icons/quad_icon_white.png"
import recovery from "@/assets/icons/recovery_icon_new.png"
import redX from "@/assets/icons/red_x_icon.png"
import reports from "@/assets/icons/reports_navi_icon.png"
import reportsSubmitted from "@/assets/icons/reports_submitted.png"
import request from "@/assets/icons/request_img.png"
import resting from "@/assets/icons/resting_hr_icon.png"
import running from "@/assets/icons/running_icon_new.png"
import settings from "@/assets/icons/settings_btn.png"
import shoppingCart from "@/assets/icons/shopping_cart_larg.png"
import shoulderRed from "@/assets/icons/shoulder_icon_red.png"
import shoulderWhite from "@/assets/icons/shoulder_icon_white.png"
import showReport from "@/assets/icons/show_report_icon.png"
import sickRed from "@/assets/icons/sick_icon_red.png"
import sickWhite from "@/assets/icons/sick_icon_white.png"
import squad from "@/assets/icons/squad_img2.png"
import star from "@/assets/icons/star.png"
import strength from "@/assets/icons/strength_icon_new.png"
import striker from "@/assets/icons/striker_icon.png"
import table from "@/assets/icons/table_image.png"
import tactics from "@/assets/icons/tactics_icon.png"
import teamRed from "@/assets/icons/team_icon_red.png"
// import team from "@/assets/icons/team_img.png"
import technical from "@/assets/icons/technical_icon_new.png"
import threePeople from "@/assets/icons/three_people_img.png"
import timer from "@/assets/icons/timer_icon.png"
import totalEvent from "@/assets/icons/total_event_icon.png"
import training from "@/assets/icons/training_icon_new.png"
import twoPeople from "@/assets/icons/two_people_img.png"
import attackingMid from "@/assets/icons/attackingMidIcon.png"
import centerBack from "@/assets/icons/centerBackIcon.png"
import centerForward from "@/assets/icons/centerForwardIcon.png"
import centralMid from "@/assets/icons/centralMidIcon.png"
import defensiveMid from "@/assets/icons/defensiveMidIcon.png"
import fullBack from "@/assets/icons/fullBackIcon.png"
import winger from "@/assets/icons/wingerIcon.png"
export default {
  icons: {
    addComment,
    addEventHome,
    addEventIcon,
    addEvent,
    addReport: addEventIcon,
    addSquad,
    ankleRed,
    ankleWhite,
    appLoginLogo,
    armRed,
    armWhite,
    attendingEvent,
    attending,
    backRed,
    backWhite,
    basket,
    basketWhite,
    calfRed,
    calfWhite,
    chestRed,
    chestWhite,
    clock,
    coachRed,
    coach,
    commentAdded,
    contentCopy,
    contentCopyWhite,
    currentStreak,
    defaultProfileImg,
    defaultIcon,
    defaultTeamImg,
    defender,
    eventCreatorGrey,
    eventCreator,
    eventSharingOff,
    eventSharingOn,
    eventsCalendar,
    event,
    fivePeople,
    footRed,
    footWhite,
    fourPeople,
    game,
    goalkeeper,
    graph,
    greenCheck,
    groinRed,
    groinWhite,
    hamstringRed,
    hamstringWhite,
    headRed,
    headWhite,
    hipRed,
    hipWhite,
    home,
    injuredPlayer,
    injury,
    joinTeam,
    kneeRed,
    kneeWhite,
    launchBanner,
    location,
    logOut,
    manageSquadDrawer,
    meeting,
    messageInbox,
    messengerIcon,
    midfielder,
    miscInjury,
    happy,
    neutral,
    sad,
    myStatus,
    neckRed,
    neckWhite,
    newMessage,
    noResponseEvent,
    noResponse,
    notAttending,
    notSelected,
    onePerson,
    pinRed,
    player,
    profile,
    quadRed,
    quadWhite,
    recovery,
    redX,
    reports,
    reportsSubmitted,
    request,
    resting,
    running,
    settings,
    shoppingCart,
    shoulderRed,
    shoulderWhite,
    showReport,
    sickRed,
    sickWhite,
    squad,
    star,
    strength,
    striker,
    table,
    tactics,
    teamRed,
    team: defaultTeamImg,
    technical,
    threePeople,
    timer,
    totalEvent,
    training,
    twoPeople,
    attackingMid,
    centerBack,
    centerForward,
    centralMid,
    defensiveMid,
    fullBack,
    winger,
  },
  userAttendingStatus: {
    attending: 0,
    notAttending: 1,
    noResponse: 2,
  },
  positions: {
    goalkeeper: "Goalkeeper",
    defender: "Defender",
    midfielder: "Midfielder",
    forward: "Forward",
    attackingMid: "Attacking Midfielder",
    centerBack: "Center Back",
    centerForward: "Center Forward",
    centralMid: "Central Midfielder",
    defensiveMid: "Defensive Midfielder",
    fullBack: "Full Back",
    winger: "Winger",
  },
  playerStatus: {
    viewType: {
      graph: 0,
      report: 1,
    },
    viewTime: {
      week: 0,
      month: 1,
      moreMonths: 2,
      all: 3,
    },
    stats: {
      overall: 0,
      soreness: 1,
      fatigue: 2,
      stress: 3,
      sleep: 4,
    },
    statsNumber: {
      0: "Overall",
      1: "Soreness",
      2: "Fatigue",
      3: "Stress",
      4: "Sleep",
    },
  },
  months: {
    0: "January",
    1: "February",
    2: "March",
    3: "April",
    4: "May",
    5: "June",
    6: "July",
    7: "August",
    8: "September",
    9: "October",
    10: "November",
    11: "December",
  },
}
